import { Injectable, Injector } from "@angular/core";
import { MfBaseService, MfTypeInfo } from "@pattonair/material-framework";
import { Subject } from "rxjs";

const TYPE_INFO: MfTypeInfo = { className: "AucRootService" };

@Injectable()
export class AucRootService extends MfBaseService {
  public showFooterChanged: Subject<boolean> = new Subject();

  public get showFooter() {
    return this._showFooter;
  }
  public set showFooter(value) {
    if (this._showFooter !== value) {
      this._showFooter = value;
      this.showFooterChanged.next(this._showFooter);
    }
  }

  protected _showFooter = true;

  public constructor(
    protected override _injector: Injector,
  ) {
    super(TYPE_INFO, _injector);
  }
}